module.exports = __webpack_public_path__ + "img/birg-teacher.2449079e.png";